import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TripAccessService } from '../services/trip-access/trip-access.service';
import { TripService } from '../services/trip.service';

/** Trip Documents page: isLead only. Allowed on mobile (unlike Group Management). */
export const tripDocumentsGuard: CanActivateFn = () => {
  const router = inject(Router);
  const tripService = inject(TripService);
  const tripAccess = inject(TripAccessService);

  if (!tripService.currentTripLoaded()) {
    return true;
  }

  const trip = tripService.currentTrip.value();
  if (tripAccess.context(trip)?.isLead !== true) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
